import { Box, Button, Flex, FlexProps, useDisclosure } from '@chakra-ui/react';
import { BLACK_BG_COLOR, MAX_CONTENT_WIDTH, PURE_NAV_HEIGHT, SITE_MIN_MARGIN } from '../const';
import { CaravanFilterForm } from '../forms/CaravanFilterForm';
import { SearchFormModal } from '../forms/SearchFormModal';
import { useTempFormSubmit } from '../forms/useTempFormSubmit';
import { useIsMobile } from '../hooks/useIsMobile';

export const EditSearchForm: React.FC<FlexProps> = (props) => {
  const isMobile = useIsMobile();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { confirmSearch, formDisabled } = useTempFormSubmit();

  if (isMobile) {
    return (
      <>
        <SearchFormModal isOpen={isOpen} onClose={onClose} />
        <Box bg={BLACK_BG_COLOR} w="100%" px={4} py={6} position="sticky" top={PURE_NAV_HEIGHT} zIndex={999}>
          <Button
            variant="blue"
            w="100%"
            color="white"
            px={2}
            py={3}
            fontWeight="20px"
            lineHeight="30px"
            onClick={onOpen}
            disabled={formDisabled}
          >
            Search
          </Button>
        </Box>
      </>
    );
  }

  return (
    <Box bg={BLACK_BG_COLOR} w="100%" px={SITE_MIN_MARGIN} py={4} position="sticky" top={PURE_NAV_HEIGHT} zIndex={999}>
      <Flex gap={{ base: 2, lg: 6 }} flexDir="row" maxW={MAX_CONTENT_WIDTH} mx="auto" {...props}>
        <CaravanFilterForm />

        <Button
          flex={1}
          variant="yellow"
          fontWeight="bold"
          borderRadius="20px"
          borderWidth="1px"
          mt="auto"
          p={0}
          onClick={confirmSearch}
        >
          Search Now
        </Button>
      </Flex>
    </Box>
  );
};
